/**
 * @fileoverview Input/output schemas for the chapter-boundary-detector-v1 agent.
 *
 * This agent scans a document to identify chapter boundaries only —
 * headings, first/last lines, and titles. No rich metadata.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { ChapterBoundarySchema } from '@/domains/chapter-workspace/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

export const InputSchema = BaseFlowInputSchema.extend({
  textInput: z.string().describe('The full text content of the document to analyze.'),
}).merge(AGENT_SCHEMA_OBJECTS.storyContext.schema);

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  chapters: z.array(ChapterBoundarySchema).describe('An array of all chapter boundaries detected in the document.'),
});

export type Output = z.infer<typeof OutputSchema>;
